(function () {
  const CHAT_LINK_HASHES = ["#open-chat", "#chatwoot"];

  function isChatLink(link) {
    if (!link || link.tagName !== "A") {
      return false;
    }

    if (link.hasAttribute("data-chatwoot-open")) {
      return true;
    }

    const href = link.getAttribute("href") || "";
    return CHAT_LINK_HASHES.some((hash) => href === hash || href.endsWith(hash));
  }

  function openWidget() {
    if (!window.$chatwoot) {
      return false;
    }

    window.$chatwoot.toggle("open");
    return true;
  }

  function open() {
    if (openWidget()) {
      return;
    }

    document.addEventListener("chatwoot:ready", () => openWidget(), { once: true });
  }

  window.ChatwootLauncher = {
    open,
  };

  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (!isChatLink(link)) {
      return;
    }

    event.preventDefault();
    open();
  });
})();
